import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import CreateAudienceFlow from "../components/whatsapp/audience/CreateAudienceFlow";
import WhatsAppAudienceList from "../components/whatsapp/audience/WhatsAppAudienceList";
import WhatsAppAudienceDetails from "../components/whatsapp/audience/WhatsAppAudienceDetails";

const WhatsAppAudience = ({ view = "list" }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  if (view === "create") {
    return (
      <CreateAudienceFlow
        onBack={() => navigate(-1)}
        onFinish={() => navigate("/campaigns/audience")}
      />
    );
  }

  if (view === "details") {
    return <WhatsAppAudienceDetails audienceId={id} />;
  }

  return (
    <WhatsAppAudienceList 
      onCreateClick={() => navigate("/campaigns/audience/create")} 
    />
  );
};

export default WhatsAppAudience;
